import { isNotNull, isNil } from '@grandvisionhq/utils';
import { NONRECOVERABLE_ERROR, RECOVERABLE_ERROR } from '../../../../../../../types/generic-query-errors.js';
import '../../../../../../../types/product.js';

const failedNonRecoverable = {
    type: 'FAILED',
    error: NONRECOVERABLE_ERROR
};
const failedRecoverable = {
    type: 'FAILED',
    error: RECOVERABLE_ERROR
};
const mapServerToClientPrescriptionCLProduct = (result)=>{
    var ref, ref1;
    const data = result.getContactLensByPrescription;
    if (data.__typename === 'GetContactLensByPrescriptionFailureResponse') {
        data.failures.forEach((failure)=>console.error(failure.message)
        );
        if (data.failures.some((failure)=>failure.__typename === 'ProductNotFoundFailure'
        )) {
            return failedNonRecoverable;
        }
        return failedRecoverable;
    }
    const rawFoundProduct = data.result.variants[0];
    if (!rawFoundProduct) {
        console.error('getContactLensByPrescription query unexpectedly returned an empty array');
        return failedNonRecoverable;
    }
    const { isAllowBackOrder , inventory  } = rawFoundProduct;
    const allowBackOrder = isNotNull(isAllowBackOrder) ? isAllowBackOrder : undefined;
    // If the stock status is not defined, we assume the product is out of stock.
    const stockIndicatorStatus = ((ref = rawFoundProduct.inventory) === null || ref === void 0 ? void 0 : ref.stockIndicator) === 'UNKNOWN' ? 'OUT_OF_STOCK' : (ref1 = rawFoundProduct.inventory) === null || ref1 === void 0 ? void 0 : ref1.stockIndicator;
    return {
        type: 'SUCCESS',
        prescriptionCLProduct: {
            sku: rawFoundProduct.sku,
            allowBackOrder,
            availableQuantity: isNil(inventory === null || inventory === void 0 ? void 0 : inventory.totalQuantity) ? 0 : inventory === null || inventory === void 0 ? void 0 : inventory.totalQuantity,
            stockIndicatorStatus
        }
    };
};

export { mapServerToClientPrescriptionCLProduct };
//# sourceMappingURL=map-to-client-prescription-contact-lens-product.js.map
